export const GRN_DOCUMENT_TYPES = [
    { value: 'invoice', label: 'Invoice' },
    { value: 'delivery_challan', label: 'Delivery Challan' },
    { value: 'eway_bill', label: 'E-Way Bill' },
    { value: 'weighment_slip', label: 'Weighment Slip' },
    { value: 'other', label: 'Others' },
];

export const GRN_DOCUMENT_ACCEPT =
    '.pdf,.jpg,.jpeg,.png,.webp,.gif,.bmp,.tif,.tiff,.doc,.docx,.xls,.xlsx';

export const GRN_DOCUMENT_MAX_BYTES = 15 * 1024 * 1024;

const LABELS = GRN_DOCUMENT_TYPES.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
}, {});

export function getGrnDocumentTypeLabel(docType) {
    return LABELS[docType] || docType || '';
}

export function mapSavedGrnDocument(doc) {
    return {
        id: doc.id,
        doc_type: doc.doc_type,
        original_name: doc.original_name || '',
        fileUrl: doc.file || '',
        file: null,
        isPending: false,
    };
}

export function createPendingGrnDocument(docType, file) {
    return {
        id: `pending-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        doc_type: docType,
        original_name: file.name,
        fileUrl: URL.createObjectURL(file),
        file,
        isPending: true,
    };
}

export function revokePendingGrnDocument(doc) {
    if (doc && doc.isPending && doc.fileUrl && String(doc.fileUrl).startsWith('blob:')) {
        URL.revokeObjectURL(doc.fileUrl);
    }
}

export function openGrnDocument(doc) {
    const url = doc && doc.fileUrl;
    if (!url) {
        return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
}
